import { IntlFormatters } from 'react-intl';
import * as yup from 'yup';
import { getOryPasswordValidationScheme } from '../../../../validations/oryPasswordValidationSchema';

export interface IActivateAccountFormData {
  feedback: boolean;
  password: string;
}

export enum FormFieldNames {
  Feedback = 'feedback',
  Password = 'password',
}

export const defaultValues: IActivateAccountFormData = {
  feedback: false,
  password: '',
};

export function getActivateAccountValidationScheme(formatMessage: IntlFormatters['formatMessage']) {
  return yup.object().shape({
    [FormFieldNames.Feedback]: yup.boolean().required(),
    [FormFieldNames.Password]: getOryPasswordValidationScheme(formatMessage),
  });
}
